// ============================================
// ADS Reklam Ajansı - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const adsReklamAjansiContent: BlogContent = {
  tableOfContents: [
    { id: "ajans-secim-kriterleri", title: "Ajans Seçim Kriterleri" },
    { id: "hizmet-paketleri", title: "Hizmet Paketleri" },
    { id: "sozlesme", title: "Sözleşme Koşulları" },
    { id: "sikca-yapilan-hatalar", title: "Sıkça Yapılan Hatalar" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>ADS reklam ajansı</strong> seçmek kritik bir karar olup, işletmenizin online başarısını doğrudan etkiler. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> binlerce ajans-müşteri ilişkisine tanıklık ettim ve bu kapsamlı rehberde, doğru ADS reklam ajansını seçmek için bilmeniz gereken her şeyi paylaşacağım."
    },
    
    { type: "heading", value: "Ajans Seçim Kriterleri", id: "ajans-secim-kriterleri" },
    { 
      type: "paragraph", 
      value: "<strong>ADS reklam ajansı</strong> seçerken sadece fiyata değil, birçok farklı kritere dikkat etmeniz gerekir. İşte en önemli 10 kriter:" 
    },
    {
      type: "subheading",
      value: "1. Deneyim ve Uzmanlık"
    },
    {
      type: "list",
      items: [
        "<strong>Sektör Deneyimi:</strong> Ajansın sizin sektörünüzde daha önce çalışmış olması büyük avantajdır. Sektörel CPC ortalamaları, dönüşüm oranları ve rakip stratejileri hakkında bilgi sahibidirler.",
        "<strong>Google Partner Statüsü:</strong> Google Partner veya Premier Partner rozeti olan ajanslar, Google'ın standartlarına uygunluğunu kanıtlamıştır.",
        "<strong>Yıllık Deneyim:</strong> En az 3-5 yıllık Google Ads deneyimi olan ajansları tercih edin.",
        "<strong>Sertifikalar:</strong> Google Ads Arama, Display, Video, Shopping sertifikalarına sahip kaç uzman var?",
        "<strong>Portföy Büyüklüğü:</strong> Kaç aktif müşteri yönetiliyor? (30-100 arası ideal, çok küçük ya da çok büyük riskli olabilir)"
      ]
    },
    {
      type: "subheading",
      value: "2. Referanslar ve Case Study'ler"
    },
    {
      type: "list",
      items: [
        "<strong>Somut Sonuçlar:</strong> Önceki projelerde elde edilen CPC azalışı, CTR artışı, ROI iyileşmesi gibi somut metrikleri görebiliyor musunuz?",
        "<strong>İsim Vermeden Paylaşım:</strong> Gizlilik anlaşmaları nedeniyle müşteri ismi paylaşamayabilirler ancak rakamlar ve grafikler paylaşabilmeliler.",
        "<strong>Gerçek Müşteri Yorumları:</strong> Google My Business, Trustpilot, LinkedIn gibi platformlardaki gerçek yorumları okuyun.",
        "<strong>Referans Görüşmesi:</strong> Mümkünse mevcut müşterilerle konuşma fırsatı isteyin.",
        "<strong>Uzun Vadeli Müşteriler:</strong> 2+ yıldır çalıştıkları müşterileri var mı? Bu memnuniyetin göstergesidir."
      ]
    },
    {
      type: "subheading",
      value: "3. Hizmet Kapsamı"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipleri:</strong> Arama, Display, Shopping, Video, Performance Max, Local - hepsinde uzmanlıkları var mı?",
        "<strong>Strateji Geliştirme:</strong> Sadece teknik kurulum mu yapıyorlar yoksa kapsamlı dijital pazarlama stratejisi mi sunuyorlar?",
        "<strong>Landing Page Optimizasyonu:</strong> Reklam yönetimine ek olarak landing page A/B test ve optimizasyonu yapıyorlar mı?",
        "<strong>Remarketing:</strong> Remarketing ve audience stratejileri geliştiriliyor mu?",
        "<strong>Dönüşüm İzleme:</strong> Google Analytics, Tag Manager entegrasyonu ve gelişmiş dönüşüm izleme kurulumu yapılıyor mu?"
      ]
    },
    {
      type: "subheading",
      value: "4. Şeffaflık"
    },
    {
      type: "list",
      items: [
        "<strong>Hesap Erişimi:</strong> Google Ads hesabınıza tam erişim hakkınız olacak mı? (Olmalıdır!)",
        "<strong>Hesap Sahipliği:</strong> Hesap sizin kendi MCC'nizde mi olacak yoksa ajansın MCC'sinde mi? (Kendi hesabınızda olması tercih edilmelidir)",
        "<strong>Detaylı Raporlama:</strong> Haftalık/aylık raporlar ne kadar detaylı? Dashboard'a canlı erişim var mı?",
        "<strong>Harcama Şeffaflığı:</strong> Google'a ödenen reklam bütçesi ile ajans yönetim ücreti net şekilde ayrılmış mı?",
        "<strong>Strategi Paylaşımı:</strong> Ajans yaptığı optimizasyonları, değişiklikleri size açıklıyor mu yoksa gizli tutuyor mu?"
      ]
    },
    {
      type: "subheading",
      value: "5. İletişim ve Destek"
    },
    {
      type: "list",
      items: [
        "<strong>Dedicated Hesap Yöneticisi:</strong> Size özel bir hesap yöneticisi mi atanacak yoksa ortak mı olacak?",
        "<strong>İletişim Kanalları:</strong> WhatsApp, telefon, e-posta - hangi kanallara ne kadar hızlı yanıt alabiliyorsunuz?",
        "<strong>Toplantı Sıklığı:</strong> Düzenli (aylık/haftalık) görüşme ve strateji toplantıları oluyor mu?",
        "<strong>Acil Durumlar:</strong> Hesabınızda bir sorun olduğunda (ödeme hatası, kampanya durması vb.) ne kadar hızlı müdahale edilebilir?",
        "<strong>Proaktif İletişim:</strong> Sadece siz sorduğunuzda mı bilgi veriyorlar yoksa proaktif olarak fırsatları ve sorunları paylaşıyorlar mı?"
      ]
    },
    {
      type: "heading",
      value: "Hizmet Paketleri",
      id: "hizmet-paketleri"
    },
    {
      type: "paragraph",
      value: "<strong>ADS reklam ajansları</strong> genellikle farklı hizmet paketleri sunar. İşte tipik bir paket yapısı:"
    },
    {
      type: "subheading",
      value: "Başlangıç Paketi (8.000-12.000₺/ay)"
    },
    {
      type: "list",
      items: [
        "1-2 kampanya tipi yönetimi (genellikle Arama + Display)",
        "Temel anahtar kelime araştırması (50-100 kelime)",
        "Basit reklam metinleri (3-5 varyasyon)",
        "Aylık performans raporu",
        "E-posta desteği (yanıt süresi 24-48 saat)",
        "Google Analytics kurulumu",
        "En az 10.000₺ aylık reklam bütçesi gerektirir"
      ]
    },
    {
      type: "subheading",
      value: "Standart Paket (15.000-25.000₺/ay)"
    },
    {
      type: "list",
      items: [
        "3-4 kampanya tipi yönetimi (Arama, Display, Shopping, Remarketing)",
        "Detaylı anahtar kelime ve rakip analizi",
        "A/B test ile optimize edilmiş reklam metinleri (10+ varyasyon)",
        "Haftalık performans özeti + aylık detaylı rapor",
        "Telefon ve e-posta desteği (yanıt süresi 12-24 saat)",
        "Dönüşüm izleme ve Google Analytics entegrasyonu",
        "Landing page önerileri",
        "En az 25.000₺ aylık reklam bütçesi"
      ]
    },
    {
      type: "subheading",
      value: "Premium Paket (30.000-50.000₺/ay)"
    },
    {
      type: "list",
      items: [
        "Tüm kampanya tiplerinde (Arama, Display, Shopping, Video, Performance Max, Local) yönetim",
        "Kapsamlı dijital pazarlama stratejisi ve danışmanlık",
        "Sürekli A/B testing ve optimizasyon",
        "Haftalık detaylı rapor + aylık strateji toplantısı",
        "Dedicated hesap yöneticisi + WhatsApp hızlı destek",
        "Landing page tasarım ve CRO (Conversion Rate Optimization)",
        "Remarketing audience segmentasyonu",
        "Click fraud koruması ve gelişmiş analytics",
        "50.000₺+ aylık reklam bütçesi"
      ]
    },
    {
      type: "subheading",
      value: "Kurumsal Paket (50.000₺+/ay)"
    },
    {
      type: "list",
      items: [
        "Özel ajans ekibi (strateji + uzman + tasarım + analytics)",
        "Multi-channel pazarlama entegrasyonu (SEO, sosyal medya, e-posta)",
        "Gerçek zamanlı dashboard ve canlı raporlama",
        "Haftalık strateji toplantıları",
        "7/24 destek hattı",
        "Otomasyonlar ve gelişmiş teklifverme algoritmaları",
        "Uluslararası kampanya yönetimi",
        "100.000₺+ aylık reklam bütçesi"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Önemli Not:</strong> Ajans yönetim ücreti, Google'a ödediğiniz reklam bütçesinden ayrıdır. Örneğin, aylık 20.000₺ ajans ücreti + 50.000₺ Google reklam bütçesi = toplam 70.000₺ ödeme yaparsınız."
    },
    {
      type: "heading",
      value: "Sözleşme Koşulları",
      id: "sozlesme"
    },
    {
      type: "paragraph",
      value: "<strong>ADS reklam ajansı</strong> ile sözleşme imzalarken dikkat edilmesi gereken kritik noktalar:"
    },
    {
      type: "subheading",
      value: "Sözleşme Süresi"
    },
    {
      type: "list",
      items: [
        "<strong>Standart Süre:</strong> Çoğu ajans 6-12 aylık minimum sözleşme ister.",
        "<strong>İdeal Süre:</strong> 3-6 ay ideal başlangıç süresidir. İlk 3 ayda ajansı test edip, memnun kalırsanız uzatabilirsiniz.",
        "<strong>Uzun Sözleşmeler:</strong> 12 ay+ sözleşme imzalarken dikkatli olun. Memnun kalmazsanız çıkmanız zor olabilir.",
        "<strong>Otomatik Yenileme:</strong> Sözleşme otomatik yenileniyor mu? Yenileme için ne kadar önceden bildirim yapmanız gerekiyor? (1-2 ay ideal)",
        "<strong>Deneme Süresi:</strong> Bazı ajanslar ilk ay deneme süresi sunabilir - mümkünse bunu talep edin."
      ]
    },
    {
      type: "subheading",
      value: "Ödeme Koşulları"
    },
    {
      type: "list",
      items: [
        "<strong>Ödeme Zamanı:</strong> Genellikle aylık peşin ödeme talep edilir.",
        "<strong>KDV:</strong> Ücretler KDV dahil mi hariç mi? Net fiyatı öğrenin.",
        "<strong>Kurulum Ücreti:</strong> İlk ay ek kurulum ücreti var mı? (Genellikle 2.000-5.000₺)",
        "<strong>Fatura:</strong> Düzenli fatura kesiliyor mu? (Vergi indirimi için önemli)",
        "<strong>Ödeme Yöntemi:</strong> Banka havalesi, kredi kartı, çek - hangi ödeme yöntemlerini kabul ediyorlar?"
      ]
    },
    {
      type: "subheading",
      value: "Erken Sonlandırma"
    },
    {
      type: "list",
      items: [
        "<strong>Sonlandırma Şartları:</strong> Sözleşmeyi erken bitirmek isterseniz ne olur?",
        "<strong>Ceza Bedeli:</strong> Erken sonlandırma cezası var mı? Ne kadar? (1-2 aylık ücret tutarında ceza makuldür)",
        "<strong>Bildirim Süresi:</strong> Kaç gün önceden bildirimde bulunmanız gerekir? (30 gün ideal)",
        "<strong>Hesap Devri:</strong> Sözleşme bittiğinde Google Ads hesabı kontrolü size sorunsuz geçecek mi?",
        "<strong>Veri Paylaşımı:</strong> Ayrıldığınızda mevcut kampanya verileri, stratejiler size teslim edilecek mi?"
      ]
    },
    {
      type: "subheading",
      value: "Performans Garantileri"
    },
    {
      type: "list",
      items: [
        "<strong>Gerçekçi Beklentiler:</strong> '1. sıra garantisi' veya 'kesin satış artışı garantisi' gibi vaatlerden kaçının - bunlar aldatıcıdır.",
        "<strong>Makul Hedefler:</strong> İlk 3 ay içinde beklenen CTR, CPC, dönüşüm oranı iyileştirmeleri nelerdir?",
        "<strong>Performans Değerlendirmesi:</strong> Hangi metriklere göre performans değerlendirilecek?",
        "<strong>Yetersiz Performans:</strong> Belirlenen hedeflere ulaşılamazsa ne olur? İade veya ücretsiz ek hizmet gibi teminatlar var mı?",
        "<strong>Raporlama:</strong> Ne sıklıkla ve ne kadar detaylı raporlama yapılacak?"
      ]
    },
    {
      type: "subheading",
      value: "Hesap Sahipliği ve Erişim"
    },
    {
      type: "list",
      items: [
        "<strong>Hesap Sahipliği:</strong> Google Ads hesabı kimin adına olacak? (Sizin adınıza olmalıdır)",
        "<strong>Admin Erişimi:</strong> Hesaba admin erişiminiz olacak mı? (Mutlaka olmalıdır)",
        "<strong>MCC Yapısı:</strong> Hesap ajansın MCC'sinde mi yoksa kendi MCC'nizde mi yönetilecek? (Kendi MCC'nizde olması idealdir)",
        "<strong>Kampanya Verileri:</strong> Sözleşme bittiğinde tüm kampanya geçmişi ve verileri size ait mi?",
        "<strong>Google Ads Bütçesi:</strong> Reklam ödemeleri kimin kredi kartından/hesabından yapılıyor? (Kendi hesabınızdan yapılması idealdir)"
      ]
    },
    {
      type: "heading",
      value: "Sıkça Yapılan Hatalar",
      id: "sikca-yapilan-hatalar"
    },
    {
      type: "paragraph",
      value: "ADS reklam ajansı seçerken işletmelerin yaptığı en yaygın 10 hata:"
    },
    {
      type: "subheading",
      value: "1. Sadece Fiyata Odaklanmak"
    },
    {
      type: "list",
      items: [
        "En ucuz ajans, en iyi ajans değildir. Düşük fiyat genellikle düşük kalite demektir.",
        "Aylık 5.000₺'ye 'her şey dahil' paket sunan ajanslar genellikle yeterli zaman ayıramaz.",
        "Hesaplayın: Ajans yönetim ücreti, reklam bütçenizin %20-30'u arasında olmalıdır.",
        "Örnek: 20.000₺ aylık reklam bütçeniz varsa, 4.000-6.000₺ ajans ücreti makuldür."
      ]
    },
    {
      type: "subheading",
      value: "2. Uzun Sözleşme İmzalamak"
    },
    {
      type: "list",
      items: [
        "İlk defa çalışacağınız ajansla 12 ay+ sözleşme imzalamayın.",
        "İlk 3-6 ay test edin, memnun kalırsanız uzatın.",
        "Otomatik yenileme şartlarını kontrol edin.",
        "Erken sonlandırma cezalarını öğrenin."
      ]
    },
    {
      type: "subheading",
      value: "3. Hesap Erişimini Vermemek"
    },
    {
      type: "list",
      items: [
        "Ajans 'güvenlik' adı altında size hesap erişimi vermiyorsa, bu büyük bir kırmızı bayraktır.",
        "Hesabınızın admin erişimine sahip olmalısınız.",
        "Ajans sizin hesabınızı kendi MCC'sinde yönetmeli, ancak hesap sahipliği size ait olmalıdır.",
        "Şeffaf olmayan ajanslardan uzak durun."
      ]
    },
    {
      type: "subheading",
      value: "4. İlk Ay Sonuçlara Odaklanmak"
    },
    {
      type: "list",
      items: [
        "Google Ads optimizasyonu zaman alır. İlk 30-60 gün test ve öğrenme süresidir.",
        "İlk ay hemen sonuç beklemek ve sabırsızlık göstermek sık yapılan bir hatadır.",
        "En az 90 gün verin, sonra performansı değerlendirin.",
        "Elbette ilk aydan itibaren iyileşme olmalı, ancak maksimum ROI 3-6 ayda gelir."
      ]
    },
    {
      type: "subheading",
      value: "5. Tek Metriğe Odaklanmak"
    },
    {
      type: "list",
      items: [
        "Sadece CTR'ye, sadece CPC'ye veya sadece gösterim sayısına bakmayın.",
        "Asıl önemli olan: Dönüşüm oranı, dönüşüm maliyeti (CPA), ROI (ROAS).",
        "Yüksek trafik ancak düşük dönüşüm = başarısız kampanya.",
        "Düşük trafik ancak yüksek dönüşüm = başarılı kampanya olabilir."
      ]
    },
    {
      type: "subheading",
      value: "6. İletişimsizlik"
    },
    {
      type: "list",
      items: [
        "Ajans ile düzenli iletişim kurmamak, fırsatları kaçırmak demektir.",
        "İşletmenizde olan değişiklikleri (yeni ürün, promosyon, sezon) ajansa zamanında bildirin.",
        "Aylık raporları sadece almakla kalmayın, okuyun ve sorular sorun.",
        "Proaktif iletişim, kampanya başarısını artırır."
      ]
    },
    {
      type: "subheading",
      value: "7. Landing Page'i İhmal Etmek"
    },
    {
      type: "list",
      items: [
        "Mükemmel Google Ads kampanyası, kötü landing page ile başarısız olur.",
        "Landing page hızı, mobil uyum, CTA netliği kritiktir.",
        "Ajansın landing page optimizasyonu önerileri varsa dikkate alın.",
        "A/B testler ile landing page'inizi sürekli iyileştirin."
      ]
    },
    {
      type: "subheading",
      value: "8. Rakip Takibi Yapmamak"
    },
    {
      type: "list",
      items: [
        "Ajansınızdan Auction Insights raporu isteyin - rakiplerinizin ne yaptığını görün.",
        "Rakiplerinizin reklam metinlerini, landing page'lerini inceleyin.",
        "Rakip analizi ile kendi stratejinizi güçlendirin.",
        "Ajans proaktif olarak rakip analizini yapmalıdır."
      ]
    },
    {
      type: "subheading",
      value: "9. Negatif Kelime İhmali"
    },
    {
      type: "list",
      items: [
        "Negatif kelimeler, bütçenizi israf aramalara harcamaktan korur.",
        "Ajans düzenli olarak Search Terms raporunu kontrol etmeli ve negatif kelime eklemeli.",
        "İlgisiz aramalara reklamınız gösteriliyorsa, bütçeniz boşa gidiyor demektir.",
        "Negatif kelime listesi sürekli güncellenmeli."
      ]
    },
    {
      type: "subheading",
      value: "10. Test Etmemek"
    },
    {
      type: "list",
      items: [
        "Sürekli aynı reklam metinleriyle, aynı stratejilerle çalışmak durgunluk yaratır.",
        "A/B test ile farklı başlıklar, açıklamalar, görseller, CTA'lar deneyin.",
        "Landing page test etmek, reklam metni test etmek kadar önemlidir.",
        "Test kültürü olan ajanslar, sürekli iyileşme sağlarlar."
      ]
    },
    {
      type: "paragraph",
      value: "<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> dayanarak söyleyebilirim ki, doğru ADS reklam ajansı seçimi ve sağlıklı bir iş birliği, işletmenizin dijital pazarlama başarısının temelidir. Bu rehberdeki kriterleri ve uyarıları dikkate alarak, hem zaman hem para kaybını önleyebilirsiniz."
    },
    {
      type: "paragraph",
      value: "<strong>ADS reklam ajansı</strong> seçimi yaparken şeffaflık, deneyim, iletişim ve gerçekçi beklentiler en önemli kriterlerdir. Sözleşme şartlarını dikkatlice okuyun, hesap erişimi ve sahipliği konusunda netlik sağlayın, ve uzun vadeli bir iş ortaklığı kurabileceğiniz güvenilir bir ajans/uzman seçin. Detaylı bilgi için <a href=\"/blog/google-ads-reklam-ajansi\" class=\"text-[#059669] hover:underline\">Google Ads reklam ajansı</a> rehberini inceleyin."
    },
    {
      type: "paragraph",
      value: "Kaynak ve destek için <a href=\"https://www.google.com/partners/\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Partners</a>, <a href=\"https://support.google.com/google-ads\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Ads Yardım</a> ve <a href=\"https://skillshop.withgoogle.com\" rel=\"nofollow\" target=\"_blank\" class=\"text-[#059669] hover:underline\">Google Skillshop</a> platformlarını ziyaret edebilirsiniz."
    },
    { type: "heading", value: "Sık Sorulan Sorular", id: "sss" },
    {
      type: "subheading",
      value: "ADS reklam ajansı ne kadar ücret alır?"
    },
    {
      type: "paragraph",
      value: "Ajans ücretleri reklam bütçenizin %10-20'si veya sabit aylık ücrettir. Küçük ajanslar 10.000-20.000₺, orta ölçek 20.000-40.000₺, büyük ajanslar 40.000₺+ aylık ücret alır."
    },
    {
      type: "subheading",
      value: "Ajans seçerken en önemli 3 kriter nedir?"
    },
    {
      type: "paragraph",
      value: "1) Google Partner statüsü ve sertifikalar, 2) Sektörünüzde kanıtlanmış deneyim ve case study'ler, 3) Şeffaf iletişim ve hesap sahipliği konusunda netlik."
    },
    {
      type: "subheading",
      value: "Sözleşmede nelere dikkat etmeliyim?"
    },
    {
      type: "paragraph",
      value: "Minimum sözleşme süresi (ideal 3-6 ay), fesih şartları, hesap sahipliği (size ait olmalı), gizli maddeler ve otomatik yenileme şartlarını dikkatlice inceleyin."
    }
  ]
};

export default adsReklamAjansiContent;
